import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '@wsphere/service-providers/domain';
import { catchError, firstValueFrom, Observable, of } from 'rxjs';

@Injectable()
export class ServiceProviderService {
  constructor(private http: HttpClient) {}

  list$(
    dto: ServiceProvider.ListServiceProvidersQueryRequest
  ): Observable<ServiceProvider.ListServiceProvidersQueryResponse> {
    return this.http.get<ServiceProvider.ListServiceProvidersQueryResponse>(`/api/service-providers`, {
      params: {
        ...(dto.page && { page: dto.page }),
        ...(dto.limit && { limit: dto.limit }),
        ...(dto.search && { search: dto.search }),
        ...(dto.status && { status: dto.status }),
        ...(dto.sortBy && { sortBy: dto.sortBy }),
        ...(dto.sortOrder && { sortOrder: dto.sortOrder }),
      },
    });
  }

  /** Active providers only; guarded by the claim edit permission, not a provider role. */
  claimLookup$(search: string, limit = 10): Observable<ServiceProvider.ListServiceProvidersQueryResponse> {
    return this.http.get<ServiceProvider.ListServiceProvidersQueryResponse>(`/api/service-providers/claim-lookup`, {
      params: { limit, ...(search && { search }) },
    });
  }

  async getOne(serviceProviderId: string) {
    return await firstValueFrom(
      this.http.get<ServiceProvider.Model>(`/api/service-providers/${serviceProviderId}`).pipe(
        catchError(err => {
          if (err.status === 404) return of(null);
          throw err;
        })
      )
    );
  }

  async create(body: ServiceProvider.CreateServiceProviderRequest) {
    return await firstValueFrom(
      this.http.post<ServiceProvider.CreateServiceProviderResponse>(`/api/service-providers`, body)
    );
  }

  async update(serviceProviderId: string, body: ServiceProvider.UpdateServiceProviderRequest) {
    return await firstValueFrom(
      this.http.patch<ServiceProvider.UpdateServiceProviderResponse>(
        `/api/service-providers/${serviceProviderId}`,
        body
      )
    );
  }

  async activate(serviceProviderId: string) {
    return await firstValueFrom(
      this.http.patch<ServiceProvider.ActivateServiceProviderResponse>(
        `/api/service-providers/${serviceProviderId}/activate`,
        {}
      )
    );
  }

  async deactivate(serviceProviderId: string) {
    return await firstValueFrom(
      this.http.patch<ServiceProvider.DeactivateServiceProviderResponse>(
        `/api/service-providers/${serviceProviderId}/deactivate`,
        {}
      )
    );
  }
}
